const employees = {
  headerButtons: {
    create: {
      createBtn: 'הוסף',
    },
  },

  edit: {
    tabs: {
      information: 'מידע',
      history: 'היסטוריה',
      bookingHistory: 'היסטוריית הזמנות',
    }
  },

  table: {
    headers: {
      createBtn: 'הוסף',
      name: 'שם',
      email: 'אימייל',
      phone: 'טלפון',
      homeAddress: 'כתובת בית',
      workAddress: 'כתובת עבודה',
      createdAt: 'נוצר בתאריך',
      createdBy: 'נוצר על ידי',
    },
  },
  form: {
    header: {
      create: {
        title: 'הוסף',
      },

      update: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    actions: {
      header: 'פעולות',
      buttons: {
        resetPassword: 'איפוס סיסמה',
      },
    },

    sections: {
      profiles: {
        header: 'פרופילים',
        fields: {
          profiles: {
            label: 'פרופילים',
          },
          attributes: {
            label: 'מאפיינים'
          }
        },
      },
      personalDetails: {
        header: 'פרטים אישיים',
        fields: {
          firstName: {
            label: 'שם פרטי',
          },
          lastName: {
            label: 'שם משפחה',
          },
          email: {
            label: 'אימייל',
          },
          phone: {
            label: 'טלפון',
          },
          additionalPhone: {
            label: 'טלפון נוסף',
          },
        },
      },
      addresses: {
        header: 'כתובות עובד',
        fields: {
          workAddress: {
            label: 'כתובת עבודה',
          },
          homeAddress: {
            label: 'כתובת בית',
          },
          additionalHomeAddress: {
            label: 'כתובת בית 2',
          },
        },
      },
    },
  },

  create: {
    confirmButtonText: 'שמור',
    toasts: {
      success: 'עובד נוצר בהצלחה',
      error: 'אירעה שגיאה בעת יצירת ההורה',
    },
  },
  update: {
    activeStatus: {
      statusActive: 'פעיל',
      statusDeactivate: 'לא פעיל',
    },

    suspend: {
      actionActivate: 'בטל השעיה',
      actionDeactivate: 'השעיה',
      suspendModal: {
        popupTitleDeactivation: 'השעיית נוסע',
        popupTitleActive: 'סיבת השעיה',
        popupTitleUnsuspend: 'סיבת ביטול השעיה',
        popupSubTitleDeactivation: 'בחר את סיבת ההשעיה',
        popupActionActive: 'בטל השעיית נוסע',
        popupActionDeactivate: 'השעיית נוסע',
      },
    },
    toasts: {
      success: 'הורה עודכן בהצלחה',
      error: 'אירעה שגיאה בעת עדכון ההורה',
      fetchError: 'משהו השתבש\nאנא נסה שוב.',
    },
  },
};

export default employees;
